// export const handleDownloadBulkUploadTemplete = () => {
//   fetch('/linkfluencer-template.xlsx')
//     .then((response) => response.blob())
//     .then((blob) => {
//       const link = document.createElement('a');
//       link.href = URL.createObjectURL(blob);
//       link.download = 'linkfluencer-template.xlsx';
//       link.click();
//     });
// };
import axiosInstance from '../config/axiosConfig';
import { toast } from 'react-toastify';

export const handleDownloadBulkUploadTemplete = async () => {
  try {
    const response = await axiosInstance.get(
      '/templates/bulk-upload-template',
      {
        responseType: 'blob', // 🔑 IMPORTANT
      },
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = 'linkfluencer-template.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Download template error:', error);
    toast.error('Failed to download template');
  }
};
